import "./Footer.scss";
import TextBlock from "../../components/ui/TextBlock";
import Button from "../../components/ui/Button";
function Footer() {
	return (
		<footer>
			<div className="footer-container">
				<div className="columns-container">
					<div className="column">
						<TextBlock
							title="READY TO GET STARTED?"
							type="h1"
							align="left"
						/>

						<TextBlock
							paragraph={
								<>
									Elevate your digital presence with the 2026
									BMW Eastern Region Tier 3 program. Select
									your package and experience seamless,
									expert-led integration.
								</>
							}
							type="p-block"
							align="left"
						/>
					</div>
					<div className="column">
						<div className="buttons-container">
							<Button
								link="/enroll"
								styleName="blue"
								size="large">
								Enroll Now
							</Button>
							{/* <a
								href={strategyDeckPDF}
								className="button outline_white small_button"
								target="_blank"
								rel="noopener noreferrer">
								Explore the Strategy
							</a> */}
						</div>
						<TextBlock
							paragraph="*All campaigns run continuously, starting March 2026."
							type="disclaimer"
							align="center"
						/>
					</div>
				</div>
			</div>
			<div className="footer-container">
				<TextBlock
					title="Learn More About Your Agency Program Support"
					type="sectionHeader"
					align="center"
				/>
				<div className="columns-container">
					<div className="column">
						<img
							src={require("../../assets/footerImgs/constellation.png")}
							alt="Constellation Logo"
							className="footer-logo"
						/>
						<TextBlock
							paragraph={
								<>
									Advanced digital execution built on premium
									BMW creative, AI-powered inventory
									intelligence, and continuous performance
									optimization.
								</>
							}
							type="p-block"
							align="center"
							color="white"
						/>
						<Button
							link="https://www.helloconstellation.com/bmw-eastern"
							styleName="purpleGradient"
							size="large">
							Learn More
						</Button>
					</div>
					<div className="column">
						<img
							src={require("../../assets/footerImgs/purecar.png")}
							alt="Constellation Logo"
							className="footer-logo"
						/>
						<TextBlock
							paragraph={
								<>
									Smarter digital advertising that turns
									inventory into demand and drives measurable
									results.
								</>
							}
							type="p-block"
							align="center"
							color="white"
						/>
						<Button
							link="https://info.purecars.com/bmw-er-blitz"
							styleName="white"
							size="large">
							Learn More
						</Button>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
